module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block date-filter"
  }, [_c('datepicker', {
    attrs: {
      "format": "dd.MM.yyyy",
      "language": _vm.$store.state.lang === 'en' ? 'en' : 'ru',
      "wrapper-class": "filter-period-wrapper",
      "input-class": "filter-period-input filter-for-date",
      "monday-first": true,
      "clear-button": _vm.clearBtn,
      "name": "filterDateField"
    },
    on: {
      "selected": _vm.valueSelected
    },
    model: {
      value: (_vm.Value),
      callback: function($$v) {
        _vm.Value = $$v
      },
      expression: "Value"
    }
  }), _vm._v(" "), (!_vm.notClose) ? _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeFilter')
      }
    }
  }, [_vm._v("×")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-175b1b62"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/filterDate.vue
// module id = 677
// module chunks = 0